import { skipToken, useQuery } from '@tanstack/react-query';

import { Clips } from '@air/api';
import { type WorkspaceInfo } from '@air/api/types';
import { callAirApi } from '@air/utils-api';

export type ClipsGetInput = Omit<Required<Parameters<typeof Clips.get>>[0], 'workspaceId'> & {
  workspaceId: WorkspaceInfo['id'];
};

export type UseClipOptions = {
  enabled: boolean;
};

export const CLIP_KEY = 'CLIP';
export type ClipKey = [typeof CLIP_KEY, ClipsGetInput];
export const getClipKey = (params: ClipsGetInput): ClipKey => [
  CLIP_KEY,
  {
    workspaceId: params.workspaceId,
    clipId: params.clipId,
  },
];

export const useClip = ({ clipId, workspaceId }: ClipsGetInput, options: UseClipOptions) =>
  useQuery({
    queryKey: getClipKey({ clipId, workspaceId }),
    queryFn:
      workspaceId && clipId
        ? () =>
            callAirApi(() =>
              Clips.get({
                workspaceId,
                clipId,
              }),
            )
        : skipToken,
    enabled: !!workspaceId && !!clipId && options.enabled,
  });
